import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { legalContent, parseContent } from '../legalContent';

export const LegalModal = ({ isOpen, onClose, type }) => {
  const [activeType, setActiveType] = useState(type);

  useEffect(() => {
    setActiveType(type);
  }, [type]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen || !activeType || !legalContent[activeType]) return null;

  const content = legalContent[activeType];

  return (
    <div className="legal-modal-overlay" onClick={onClose}>
      <div className="legal-modal" onClick={e => e.stopPropagation()}>
        <div className="legal-modal-header">
          <div className="legal-tabs">
            <button
              className={`legal-tab ${activeType === 'privacy' ? 'active' : ''}`}
              onClick={() => setActiveType('privacy')}
            >
              Confidențialitate
            </button>
            <button
              className={`legal-tab ${activeType === 'terms' ? 'active' : ''}`}
              onClick={() => setActiveType('terms')}
            >
              Termeni
            </button>
            <button
              className={`legal-tab ${activeType === 'cookies' ? 'active' : ''}`}
              onClick={() => setActiveType('cookies')}
            >
              Cookie-uri
            </button>
          </div>
          <button onClick={onClose} className="legal-close-btn" aria-label="Închide">
            <X size={20} />
          </button>
        </div>

        <div className="legal-modal-body">
          <h1 className="legal-title">{content.title}</h1>
          <p className="legal-updated">Ultima actualizare: {content.lastUpdated}</p>

          <div className="legal-content">
            {parseContent(content.content)}
          </div>
        </div>

        <div className="legal-modal-footer">
          <p>© {new Date().getFullYear()} Poly Tool (Poly Tool Design S.R.L.) Toate drepturile rezervate.</p>
        </div>
      </div>
    </div>
  );
};

export default LegalModal;
